import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./SetProfileIcon.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";

const SetProfileIcon = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const scrollableRef = useRef(null);
    const contentRef = useRef(null);
    const maskRef = useRef(null);
    const [defaultImgIndex, set_defaultImgIndex] = useState(-1);
    const [tagIndex, set_tagIndex] = useState(0);
    const fileInputRef = useRef(null);
    useEffect(() => {
        console.log("SetProfileIcon");
        setInProp(true);
        if (scrollableRef.current && maskRef.current) {
            const h = scrollableRef.current.clientHeight;
            maskRef.current.style.minHeight = `${h}px`;
            scrollableRef.current.style.maxHeight = `${h}px`;
            scrollableRef.current.scrollTop = h;
        }
    }, [])
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const imageUrl = URL.createObjectURL(file);
        
        const img = new Image();
        img.src = imageUrl;
    
        img.onload = () => {
            const { width, height } = img;
            let minScale = 1;
    
            if (width > height) {
                minScale = width / height;
            }
    
            addModalType({ cls: "FixPhoto", arg: { file: file, imageUrl: imageUrl, minScale: minScale,cb:imgData=>{
                arg.cb(imgData);
                setInProp(false);
            } } });
        };
    
        e.target.value = '';
    };
    
    function updateHeight() {
        if (scrollableRef.current && maskRef.current) {
            const h = contentRef.current.clientHeight;
            maskRef.current.style.minHeight = `${h}px`;
            scrollableRef.current.style.maxHeight = `${h}px`;
            scrollableRef.current.scrollTop = h;
        }
    }
    function releseHand(e) {
        if (scrollableRef.current.scrollTop < scrollableRef.current.clientHeight * .9) {
            scrollableRef.current.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
            setTimeout(() => {
                setInProp(false);
            }, 500);
        }
        else
            scrollableRef.current.scrollTo({
                top: scrollableRef.current.clientHeight,
                left: 0,
                behavior: "smooth",
            })
    }

    return (
        <div className={style.modalBottom} style={{ backgroundColor: "#00000055", overflow: "hidden" }}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "SetProfileIcon"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app} ref={scrollableRef} onTouchEnd={e => { releseHand(e) }} onMouseUp={e => { releseHand(e) }} onScroll={e => {
                                if (e.target.scrollTop === 0)
                                    setInProp(false);
                            }}>
                                <div className={styleUi.mask} ref={maskRef}>
                                </div>
                                <div className={styleUi.content} ref={contentRef} >
                                    <div className={styleUi.bg}>
                                        <div className={styleUi.bar}>
                                        </div>
                                    </div>
                                    <div className={styleUi.view}>
                                        <div className={styleUi.tabs}>
                                            <div className={`${styleUi.item} ${tagIndex === 0 ? styleUi.selected : ""}`} onClick={e => {
                                                set_tagIndex(0);
                                            }}>
                                                <img src={arg.photo} />
                                            </div>
                                            <div className={`${styleUi.item} ${tagIndex === 1 ? styleUi.selected : ""}`} onClick={e => {
                                                set_tagIndex(1);
                                            }}>
                                                <img src={"./assets/ui/avatar.svg"} />
                                            </div>
                                        </div>
                                        <div className={styleUi.content}>
                                            {tagIndex === 0 &&
                                                <>
                                                    <YStyled.BTN3 normalBg="#F2CE3E" normalColor="black" style={{ borderRadius: "99px", borderWidth: "0px", padding: "1rem" }} onClick={e => {
                                                        fileInputRef.current.click();
                                                    }}><YStyled.Span size={17}>選擇照片</YStyled.Span></YStyled.BTN3>
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        ref={fileInputRef}
                                                        style={{ display: 'none' }}
                                                        onChange={handleFileChange}
                                                    />
                                                </>
                                            }
                                            {tagIndex === 1 &&
                                                <>
                                                    <div className={styleUi.avatars}>
                                                        {
                                                            [0, 1, 2, 3, 4, 5].map((v, k) => {
                                                                return <div key={k} className={`${styleUi.avatar} ${defaultImgIndex === v ? styleUi.selected : ""}`} onClick={e => {
                                                                    set_defaultImgIndex(v)
                                                                }}>
                                                                    <img src={`./assets/ui/Avatar${(v + 1)}.png`} />
                                                                </div>
                                                            })
                                                        }
                                                    </div>
                                                    <YStyled.BTN3 disabled={defaultImgIndex === 0} normalBg="#F2CE3E" normalColor="black" disableBg="#D5D3CE" disableColor="#FFF" style={{ width: "100%", padding: ".8rem", borderWidth: "0px", borderRadius: "10px", marginTop: "1.5rem" }} onClick={e => {
                                                        arg.cb(`./assets/ui/Avatar${(defaultImgIndex+1)}.png`);
                                                        setInProp(false);
                                                    }}>
                                                        <YStyled.Span size={17} >套用</YStyled.Span>
                                                    </YStyled.BTN3>
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition >
        </div >
    );
}

export default memo(SetProfileIcon);